import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useBlog } from "../../hooks/blog/useBlog";

const SuggestedPost = ({ currentPostId, allBlogs, categories }) => {
  const { setLoading } = useBlog();
  const navigate = useNavigate();

  // Filter out the current post and get up to 3 suggested posts
  const suggestedPosts = allBlogs
    .filter((blog) => blog.id !== currentPostId)
    .slice(0, 3);

    // console.log("Suggested Posts", suggestedPosts);
    

  // Function to strip HTML tags from content
  const stripHtml = (html) => {
    if (!html) return "";
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };

  // Function to format date
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const handlePostClick = (slug) => {
    setLoading(true);
    navigate(`/blogdetail/${slug}`);
  };

  return (
    <>
      <section className="latest-blog">
        <div className="upper-heading">
          <h6>Suggested Posts</h6>
          <Link to="/blog">See All Blogs</Link>
        </div>
        <div className="bottom-cards">
          {suggestedPosts.length > 0 &&
            suggestedPosts.map((post) => (
              <Link
                to={`/blogdetail/${post.slug}`}
                
                className="single-card"
                key={post.id}
              >
                <div className="main-img">
                  <img
                    src={
                      post.jetpack_featured_media_url ||
                      "/assets/blog/dummymain.png"
                    }
                    alt={post.title.rendered}
                    className="img-fluid"
                  />
                </div>
                <div className="bottom-detail">
                  <div className="titletext">
                    <h6>{post.title.rendered}</h6>
                    <div
                      className="arrow-icon"
                      onClick={(e) => {
                        e.stopPropagation();
                        handlePostClick(post.id);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="24"
                        viewBox="0 0 25 24"
                        fill="none"
                      >
                        <path
                          d="M22.1973 10.2806L17.6973 14.7806C17.5565 14.9214 17.3656 15.0004 17.1666 15.0004C16.9676 15.0004 16.7767 14.9214 16.636 14.7806C16.4953 14.6399 16.4162 14.449 16.4162 14.25C16.4162 14.051 16.4953 13.8601 16.636 13.7194L19.8563 10.5H16.1354C14.306 10.4995 12.5283 11.107 11.0819 12.2271C9.63551 13.3472 8.60241 14.9162 8.14506 16.6875C8.09534 16.8802 7.9711 17.0453 7.79968 17.1463C7.62826 17.2474 7.4237 17.2763 7.231 17.2266C7.0383 17.1768 6.87326 17.0526 6.77216 16.8812C6.67107 16.7098 6.64221 16.5052 6.69194 16.3125C7.23158 14.2186 8.45234 12.3637 10.162 11.0398C11.8716 9.71598 13.9731 8.99836 16.1354 9H19.8582L16.636 5.78063C16.5663 5.71095 16.511 5.62822 16.4733 5.53718C16.4356 5.44613 16.4162 5.34855 16.4162 5.25001C16.4162 5.15146 16.4356 5.05388 16.4733 4.96283C16.511 4.87179 16.5663 4.78906 16.636 4.71938C16.7767 4.57865 16.9676 4.49959 17.1666 4.49959C17.2652 4.49959 17.3628 4.519 17.4538 4.55671C17.5448 4.59442 17.6276 4.6497 17.6973 4.71938L22.1973 9.21938C22.267 9.28903 22.3223 9.37175 22.36 9.4628C22.3978 9.55385 22.4172 9.65144 22.4172 9.75C22.4172 9.84857 22.3978 9.94616 22.36 10.0372C22.3223 10.1283 22.267 10.211 22.1973 10.2806ZM18.6666 19.5H4.41663V8.25001C4.41663 8.05109 4.33761 7.86033 4.19696 7.71968C4.0563 7.57902 3.86554 7.50001 3.66663 7.50001C3.46771 7.50001 3.27695 7.57902 3.1363 7.71968C2.99564 7.86033 2.91663 8.05109 2.91663 8.25001V20.25C2.91663 20.4489 2.99564 20.6397 3.1363 20.7803C3.27695 20.921 3.46771 21 3.66663 21H18.6666C18.8655 21 19.0563 20.921 19.197 20.7803C19.3376 20.6397 19.4166 20.4489 19.4166 20.25C19.4166 20.0511 19.3376 19.8603 19.197 19.7197C19.0563 19.579 18.8655 19.5 18.6666 19.5Z"
                          fill="#013159"
                        />
                      </svg>
                    </div>
                  </div>
                  <p className="para">
                    {stripHtml(post.excerpt.rendered).substring(0, 150)}...
                  </p>
                  <p className="date" style={{ color: "#627F97" }}>
                    {formatDate(post.date)}
                  </p>
                </div>
              </Link>
            ))}
        </div>
      </section>
    </>
  );
};

export default SuggestedPost;
